<template>
  <div class="animate__animated animate__fadeIn">
    <div class="header">
      <Header />
    </div>
    <div class="container">
      <router-view />
    </div>
    <Footer class="footer" />
    <!-- <a-back-top /> -->
    <div class="side-menu">
      <div @click="showWeixin">
        <img src="@assets/icon/weixin.png" alt="" />
      </div>
    </div>
    <a-modal v-model="visibleWeixin" :footer="null" :width="350">
      <img style="width: 100%" src="@assets/weixin.png" alt="" />
    </a-modal>
  </div>
</template>

<script>
import Header from "@/components/Header";
import Footer from "@/components/Footer";
export default {
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      visibleWeixin: false,
    };
  },
  mounted() {
    let that = this;
    document.addEventListener("showWeixin", function () {
      that.showWeixin();
    });
  },
  methods: {
    showWeixin() {
      this.visibleWeixin = true;
    },
  },
};
</script>
<style scoped lang="less">
.side-menu {
  background: #fff;
  padding: 10px;
  border-radius: 10px;
  position: fixed;
  right: 5px;
  bottom: 10px;
  width: 80px;
  img {
    cursor: pointer;
    max-width: 100%;
  }
}
</style>
<style lang="less">
.header {
  width: 1200px;
  margin: auto;
}

.banner {
  width: 100%;

  .banner-btns {
    height: 0;
    position: relative;
    top: -100px;
    left: 260px;
    .ant-btn {
      color: #f17f42;
      border-color: #f17f42;
    }
  }
}

.orange {
  color: #fc8a47 !important;
}

.white {
  color: #fbfbfb !important;
}

.gray-bg {
  background-color: #eeeeee;
}

.section {
  width: 100%;
  text-align: center;
  padding: 64px 0;
  background-size: cover;
  background-repeat: no-repeat;
}

.sec-content {
  width: 1200px;
  min-height: 100px;
  margin: 64px auto;
  box-sizing: border-box;
  /* 确保padding和border不溢出 */
}

.sec-title {
  font-size: 46px;
  color: #333333;
}

.sec-subtitle {
  font-size: 26px;
  color: #b2b2b2;
  max-width: 780px;
  margin: auto;
}

.footer {
  height: 32px;
}
</style>